export default __webpack_public_path__ + "static/media/logoWaterMarks.a38ae20b.svg";